@for (command of commands; track command) {
    <div class="card">
        @if ((command?.request?.schema?.fields)[0]?.schema?.enumValues === undefined) {
            <div>
                <div class="card-body">
                    <app-properties [isCommand]="false" [properties]="command?.request?.schema?.fields" [changeMarkerActive]="false" #properties> </app-properties>

                    @if ((commandError || {})[command.name]) {
                        <div class="form-text text-danger"><i class="fas fa-exclamation-circle"></i>{{ (commandError || {})[command.name] }}</div>
                    }
                </div>
                <div class="card-footer">
                    <div class="commands-properties-card-footer-content-width" [ngbTooltip]="'commands.executeCommandHint' | translation | async" [disableTooltip]="!isSelectedAssetDisabled" placement="top">
                        <button (click)="executeCommandPass(command.name, properties.values)" class="btn btn-primary" appDisabledPermission="asset.execute" [disabled]="isSelectedAssetDisabled || (isCommandExecuting || {})[command.name]">
                            @if ((isCommandExecuting || {})[command.name]) {
                                <span class="spinner-border spinner-border-sm"></span>
                            }
                            {{ 'commands.setDisplayName' | translation: { displayName: command.displayName.en } | async }}
                        </button>
                    </div>
                </div>
            </div>
        }

        @if ((command?.request?.schema?.fields)[0]?.schema?.enumValues !== undefined) {
            <div>
                <div class="card-footer">
                    <div class="commands-properties-card-footer-content-width" [ngbTooltip]="'commands.executeCommandHint' | translation | async" [disableTooltip]="!isSelectedAssetDisabled" placement="top">
                        <button (click)="executeCommand(command)" class="btn btn-primary" appDisabledPermission="asset.execute" [disabled]="isSelectedAssetDisabled || (isCommandExecuting || {})[command.name]">
                            {{
                                ((command?.request?.schema?.fields)[0]?.schema?.enumValues)[0]?.displayName?.en != null
                                    ? ((command?.request?.schema?.fields)[0]?.schema?.enumValues)[0]?.displayName?.en
                                    : ('commands.noDisplayName' | translation | async)
                            }}
                        </button>
                    </div>
                </div>
            </div>
        }
    </div>
}
